<template>
    <div>
        <div :style="'position:relative;height:' + props.height + 'vmin;top:-' + props.height + 'vmin;'">
            <div style="width: 100%; position: relative; z-index: 2" :style="'height:' + props.height + 'vmin;top:+' + props.height + 'vmin'" v-if="text !== '레슨'">
                <div
                    :style="
                        'position: relative;background-color: ' +
                        props.color +
                        ';border-radius: 50%;display: flex;align-items: center;justify-content: center; width:' +
                        props.height +
                        'vmin;height:' +
                        props.height +
                        'vmin;left:calc(' +
                        ((Number(props.value) - 1) / (Number(props.max) - 1)) * 100 +
                        '% - ' +
                        (props.value === 1 ? 0 : props.value === props.max ? props.height : props.height / 2) +
                        'vmin )'
                    "
                >
                    <div :style="'background-color: ' + props.color + ';border-radius: 50%;border: 3px solid white; width:' + props.height / 2 + 'vmin;height:' + props.height / 2 + 'vmin'"></div>
                </div>
            </div>
            <div style="width: 100%; position: relative; z-index: 2" :style="'height:' + props.height + 'vmin;top:calc(' + props.height + 'vmin - 2px)'" v-if="text === '레슨'">
                <div
                    :style="
                        'position: relative;background-color: white;border-radius: 50%;display: flex;align-items: center;justify-content: center; width:calc(' +
                        props.height +
                        'vmin + 4px);height:calc(' +
                        props.height +
                        'vmin + 4px);left:calc(' +
                        ((Number(props.value) - 1) / (Number(props.max) - 1)) * 100 +
                        '% - ' +
                        (props.value === 1 ? 0 : props.value === props.max ? props.height : props.height / 2) +
                        'vmin );border: 2px solid ' +
                        props.color +
                        ';'
                    "
                >
                    <div :style="'background-color: ' + props.color + ';border-radius: 50%; width:calc(' + props.height + 'vmin - 4px );height:calc(' + props.height + 'vmin - 4px );'"></div>
                </div>
            </div>
            <q-linear-progress rounded track-color="grey-4" :size="props.height + 'vmin'" :value="props.value === 0 ? 0 : props.value === 1 ? 0.01 : (Number(props.value) - 1) / (Number(props.max) - 1)" :style="'color:' + props.color" />
            <div style="width: 100%; display: flex; justify-content: space-between; font-size: 1.66vmin; align-items: center; padding: 0 0.83vmin; position: relative" :style="'height:' + props.height + 'vmin;top:-' + props.height + 'vmin'">
                <!-- <div v-for="i in 3"
                    style="background-color: #E0E0E0; width:1.66vmin;height:1.66vmin;border-radius: 50%;"
                    :style="(i <= Number(props.value)) ? 'visibility:hidden;' : i === props.max ? 'background-color: none;border: 2px solid #8E43F0;' : ''">
                </div> -->
                <div style="background-color: #e0e0e0; width: 1.66vmin; height: 1.66vmin; border-radius: 50%" :style="1 <= Number(props.value) ? 'visibility:hidden;' : ''"></div>
                <div style="background-color: #e0e0e0; width: 1.66vmin; height: 1.66vmin; border-radius: 50%" :style="Number(props.value) >= parseInt((Number(props.max) + 1) / 2) ? 'visibility:hidden;' : ''"></div>
                <div :style="' width:1.66vmin;height:1.66vmin;border-radius: 50%;background-color: none;border: 2px solid' + props.color + ';'"></div>
            </div>
        </div>
        <div style="width: 100%; display: flex; justify-content: space-between; font-size: 1.66vmin; margin-top: 0.2vw" :style="'color:' + textColor + ';'">
            <div>1{{ props.text }}</div>
            <div>{{ parseInt((Number(props.max) + 1) / 2) }}{{ props.text }}</div>
            <div>{{ props.max }}{{ props.text }}</div>
        </div>
    </div>
</template>

<script setup>
import { onMounted, defineProps } from 'vue';

// const chartdiv = ref(null);
const props = defineProps({
    value: {
        default: 0,
    },
    max: {
        default: 3,
    },
    height: {
        default: 3.33,
    },
    color: {
        default: 'primary',
    },
    textColor: {
        default: '#8E8E8E',
    },
    text: {
        default: '레벨',
    },
});

onMounted(() => {
    // console.log(props);
});
</script>

<style scoped lang="scss">
.rounded-borders {
    border-radius: 60px;
}
</style>
